import {appendPaginationQueryParamsToUrl, get} from '../utils'

const url = (host, {playlistId, tags, options, isPublic, search}) => 
  appendPaginationQueryParamsToUrl(`${host}${isPublic ? "/public" : ""}/playlists/${playlistId}/contentCreations?active=1${(tags && tags.length > 0) ? `&selected_tags_ids=${tags.join(',')}` : ''}${search ? `&name=${search}` : ''}`, {...options, alreadyHasQueryParams: true});

export default host => ({playlistId, tags, options, isPublic = false, search=""}) =>
  get(url(host, {playlistId, tags, options, isPublic, search}))
    .then(response => response.json())